// get btn element
const btnToggle = document.querySelectorAll('.table-toggle');

btnToggle.forEach((item, index) => {
    item.addEventListener('click', (e) => {
        const $self = e.target;
        const tableID = $self.dataset.table;
        const table = document.getElementById(tableID);

        const siblingTables = document.querySelectorAll('.table-container');
        siblingTables.forEach((element) => {
            element.style.display = "none";
        });

        table.style.display = "block";
    });
});